import baseAPI from "@/api/base";
import { EditNotification, GetNotification, RegisterNotification } from "@/dtos/Notification.dto";
import {
  DELETE_NOTIFICATION_URL,
  EDIT_NOTIFICATION_URL,
  GET_NOTIFICATION_URL,
  MARK_NOTIFICATION_SEEN_URL,
  REGISTER_NOTIFICATION_URL,
  TOGGLE_NOTIFICATION_IS_ACTIVE_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class Notification {
  static getNotifications = async (getNotification: GetNotification): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_NOTIFICATION_URL, {
      params: getNotification,
    });
    return response;
  };

  static registerNotification = async (
    registerNotification: RegisterNotification
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_NOTIFICATION_URL, {
      ...registerNotification,
    });
    return response;
  };

  static editNotification = async (editNotification: EditNotification): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_NOTIFICATION_URL, {
      ...editNotification,
    });
    return response;
  };

  static toggleNotificationIsActive = async (
    editNotification: EditNotification
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(TOGGLE_NOTIFICATION_IS_ACTIVE_URL, {
      ...editNotification,
    });
    return response;
  };

  static markNotificationSeen = async (
    editNotification: EditNotification
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(MARK_NOTIFICATION_SEEN_URL, {
      ...editNotification,
    });
    return response;
  };

  static deleteNotification = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(`${DELETE_NOTIFICATION_URL}/${id}`);
    return response;
  };
}

export default Notification;
